import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { cssFacebook } from '@ng-icons/css.gg';
import {
  ionCall,
  ionLogoApple,
  ionLogoGooglePlaystore,
  ionLogoInstagram,
  ionLogoTwitter,
  ionMail,
} from '@ng-icons/ionicons';
import { jamLinkedin } from '@ng-icons/jam-icons';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { environment } from '../../environments/environment';
import { NgTextDirective } from '../../shared/directives/ng-text.directive';
import { LoadingService } from '../../shared/services/loading.service';
import { NavbarComponent } from '../modulecomponents/navbar/navbar.component';
import { NewsletterComponent } from '../modulecomponents/newsletter/newsletter.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  imports: [
    RouterModule,
    NgTextDirective,
    NzButtonModule,
    NgIcon,
    NavbarComponent,
    NewsletterComponent,
  ],
  providers: provideIcons({
    ionLogoTwitter,
    cssFacebook,
    jamLinkedin,
    ionLogoInstagram,
    ionCall,
    ionMail,
    ionLogoApple,
    ionLogoGooglePlaystore,
  }),
})
export class FooterComponent {
  loadingService = inject(LoadingService);
  readonly appStoreUrl = environment.appStoreUrl;
  readonly googlePlayUrl = environment.googlePlayUrl;
  socialLinks = [
    { icon: 'ionLogoTwitter', url: 'https://twitter.com' },
    { icon: 'cssFacebook', url: 'https://facebook.com' },
    { icon: 'jamLinkedin', url: 'https://linkedin.com' },
    { icon: 'ionLogoInstagram', url: 'https://instagram.com' },
  ];
  contactLinks = [
    { icon: 'ionCall', url: 'tel:+1833-563-8669', text: '+1833-563-8669' },
    {
      icon: 'ionMail',
      url: 'mailto:support@joetnow.com',
      text: 'support@joetnow.com',
    },
  ];
}
